<template>
  <div ref="gridTableRef"></div>
</template>

<script>
import { init } from '@/packages/lq-ui/gridTable/service'

export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  name: 'grid-table',
  methods: {},
  mounted () {
    init(this.$refs.gridTableRef)
  }
}
</script>

<style scoped>

</style>
